import React, { useEffect, useState } from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import "./style.css";
import { useSelector, useDispatch } from "react-redux";
import Radio from "@mui/material/Radio";
import { toast } from "react-toastify";
import { coUserUpdateStatus } from "../../../../store/features/coUserUpdateStatusTeam";

function EditAgentStatus(props) {
  const [forceRerender, setForceRerender] = useState(false);
  const dispatch = useDispatch();
  const { userId, userUpdate, activeEditAgentId, setActiveEditAgentId } = props;

  const CoUserStatusUpdate = async (roleId) => {
    const CoUserUpdates = dispatch(
      coUserUpdateStatus({
        id: userId,
        requestHeaders: { agent_status_id: roleId },
      })
    );

    CoUserUpdates.then(async (data) => {
      if (data?.payload?.status === 200) {
        // Update local state immediately after successful API call
        setActiveEditAgentId(roleId);

        if (roleId !== "3") {
          toast.success(data?.payload?.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
        // Force a rerender to ensure UI updates
        setForceRerender(prev => !prev);
      } else if (data?.payload?.status === 400) {
        toast.error(data?.payload?.message || "Failed to update agent status");
        // Revert to previous state if update fails
        setActiveEditAgentId(activeEditAgentId);
      }
    }).catch(async (error) => {
      toast.error(error?.message || "An error occurred while updating status");
      // Revert to previous state if update fails
      setActiveEditAgentId(activeEditAgentId);
    });
  };

  const handleAgentSelection = (roleId) => {
    CoUserStatusUpdate(roleId);
  };

  useEffect(() => {
    // Update local state when userUpdate prop changes
    const newActiveId =
      userUpdate === "Accept Chat" ? "1"
        : userUpdate === "Don't Accept chats" ? "2"
          : userUpdate === "According to working hours" ? "3"
            : "1";

    setActiveEditAgentId(newActiveId);
  }, [userUpdate, setActiveEditAgentId]);

  const data = [
    {
      id: "1",
      text: "Accept Chat",
    },
    {
      id: "2",
      text: "Don't Accept chats",
    },
    {
      id: "3",
      text: "According to working hours",
    },
  ];

  return (
    <div className="EditAgent-Container" >
      {/* First row: first two items */}
      <div style={{ display: 'flex', gap: '8px', }}>
        {data.slice(0, 2).map((item) => (
          <div
            key={item.id}
            className={`EditAgentStatus ${activeEditAgentId === item.id ? "EditAgentActive" : ""}`}
            style={{ flex: 1, minWidth: 0 }}
          >
            <FormControlLabel
              value={item.id}
              control={<Radio />}
              label={item.text}
              sx={{
                '& .MuiFormControlLabel-label': {

                  display: 'block',
                  fontSize: '14px',
                  fontWeight: '500',
                  fontFamily: 'Inter',
                  color: '#061522'      // ensures label obeys flex shrink
                  // never exceeds container
                },
              }}
              onChange={() => handleAgentSelection(item.id)}
              checked={activeEditAgentId === item.id}
            />
          </div>
        ))}
      </div>

      {/* Second row: third item */}
      <div style={{ display: 'flex' }}>
        {data.slice(2).map((item) => (
          <div
            key={item.id}
            className={`EditAgentStatus ${activeEditAgentId === item.id ? "EditAgentActive" : ""}`}
            style={{ flex: 1, minWidth: 0 }}
          >
            <FormControlLabel
              value={item.id}
              control={<Radio />}
              label={item.text}
              sx={{
                '& .MuiFormControlLabel-label': {
                  display: 'block',
                  fontSize: '14px',
                  fontWeight: '500',
                  fontFamily: 'Inter',
                  color: '#061522'

                },
              }}
              onChange={() => handleAgentSelection(item.id)}
              checked={activeEditAgentId === item.id}
            />
          </div>
        ))}
      </div>
    </div>



  );
}

export default EditAgentStatus;